const ee = require('event-emitter');
const bus = ee();
export default bus;

